/**
 * Stansforms kebab case to camel case
 * @param {string} str
 * @returns {string}
 */
export const kebabToCamelCase = function (str) {
    return str.replace(/-./g, x => x[1].toUpperCase());
}
